import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../interceptor/axiosInstance";
import NotificationService from "../../Utils/NotificationService";

const HostingerGuide = () => {
  const [orgCode, setOrgCode] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchOrgDetails = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setOrgCode("YOUR_ORG_CODE");
        return;
      }
      try {
        const response = await axiosInstance.get(`/org/org-details`);
        const data = response.data[0];
        setOrgCode(data.organisation_code);
      } catch (error) {
        console.error('Error fetching organization details:', error);
        setOrgCode("YOUR_ORG_CODE");
      }
    };
    fetchOrgDetails();
  }, []);

  const specificPageCode = `
<div id="chat-bot-container"></div>
<script src="https://ezzdesk.com/shared_prompt.js?code=${orgCode}"></script>
  `.trim();

  const allPagesCode = `
<script>
(() => {
  function installPlatform() {
    const platform = document.createElement('script');
    platform.src = 'https://ezzdesk.com/shared_prompt.js?code=${orgCode}';
    platform.async = true;
    document.head.appendChild(platform);
  }
  function installWidget() {
    const widget = document.createElement('div');
    widget.id = 'chat-bot-container';
    document.body.prepend(widget);
    installPlatform();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installWidget);
  } else {
    installWidget();
  }
})();
</script>
  `.trim();

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }).catch((err) => {
      NotificationService.error('Failed to copy text: ' + err);
    });
  };

  const ImagePlaceholder = () => (
    <div style={{
      width: '100%',
      height: '300px',
      backgroundColor: '#f0f0f0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px dashed #ccc',
      borderRadius: '8px',
      margin: '20px 0',
      color: '#999',
      fontSize: '18px'
    }}>
      Image Placeholder
    </div>
  );

  return (
    <div style={{
      padding: '40px',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      background: '#ffffff',
      color: '#333',
      lineHeight: '1.6'
    }}>
      <h1 style={{ fontSize: '28px', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
        Adding Ezzdesk Widget to Hostinger Website
      </h1>

      <p style={{ fontSize: '16px', marginBottom: '30px', color: '#555' }}>
        Ready to install your Ezzdesk widget on Hostinger? We've got you covered! Since Hostinger requires a custom code approach, choose how to install your widget below.
      </p>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ fontSize: '22px', marginBottom: '15px' }}>Add widget to a specific page</h3>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1.</strong> Log in to your Hostinger control panel, go to the <strong>Websites</strong> tab, and click <strong>Edit website</strong> next to the website where you'd like to add the widget:
        </p>
        <img src="/assets/file-SAS2h7P0Rz.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2.</strong> In the <strong>Website Builder</strong>, open the <strong>Add elements</strong> panel on the left, then drag and drop the <strong>Embed code</strong> element to where you want it on your page:
        </p>
        <img src="/assets/file-uvUqjdR5BA.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>3.</strong> Click "Your custom embed code" and hit <strong>Enter code</strong>:
        </p>
        <img src="/assets/file-mnCppe5FAI.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>4.</strong> Insert the following code into the window:
        </p>

        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{
            background: '#f4f4f4',
            padding: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontFamily: 'Courier New, monospace',
            fontSize: '14px',
            overflowX: 'auto'
          }}>
            {specificPageCode}
          </pre>
          <button
            onClick={() => handleCopy(specificPageCode)}
            className='btn-color'
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              padding: '6px 16px',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Then click the <strong>Embed code</strong> button:
        </p>
        <img src="/assets/image_dccb2bae.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <div style={{ background: '#fff3cd', borderLeft: '4px solid #ffecb5', padding: '10px', marginBottom: '15px', fontSize: '14px' }}>
          <strong>Note:</strong> Hostinger doesn’t support widget display in editor or preview mode, so you’ll see a banner placeholder instead. Don’t worry—your widget will be fully visible on the published site!
        </div>

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>5.</strong> Click <strong>Save</strong> and <strong>Update</strong> your website:
        </p>
        <img src="/assets/file-ORoxoaqjNy.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

      </div>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ fontSize: '22px', marginBottom: '15px' }}>Add widget to all pages</h3>

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1.</strong> After logging into the Hostinger control panel, go to the <strong>Websites</strong> tab, find your site, and click <strong>Edit website</strong>:
        </p>
        <img src="/assets/file-SAS2h7P0Rz.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2.</strong> In the <strong>Website Builder</strong>, find <strong>More settings</strong>, and open <strong>Integrations</strong>:
        </p>
        <img src="/assets/file-tFn4rpve87.png" alt="Paste Code" style={{ maxWidth: '50%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>3.</strong> Paste the following script into the <strong>Custom code</strong> field:
        </p>

        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{
            background: '#f4f4f4',
            padding: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontFamily: 'Courier New, monospace',
            fontSize: '14px',
            overflowX: 'auto'
          }}>
            {allPagesCode}
          </pre>
          <button
            onClick={() => handleCopy(allPagesCode)}
            className='btn-color'
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              padding: '6px 16px',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Once you have added the code, click <strong>Save</strong>:
        </p>
        <img src="/assets/image_b33a6677.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>4.</strong> Then hit <strong>Update website</strong> to publish the widget:
        </p>
        <img src="/assets/file-Aqr0Cd3W9B.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <div style={{ background: '#fff3cd', borderLeft: '4px solid #ffecb5', padding: '10px', marginBottom: '15px', fontSize: '14px' }}>
          <strong>Note:</strong> Hostinger doesn’t support widget display in editor or preview mode. Don’t worry—your widget will be fully visible on the published site!
        </div>
      </div>

      <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '5px', borderLeft: '4px solid #007BFF' }}>
        <h4 style={{ margin: '0 0 10px 0', fontSize: '16px' }}>Need Help?</h4>
        <p style={{ margin: 0, fontSize: '14px', color: '#555' }}>
          If you encounter any issues while installing the widget, feel free to contact our support team.
        </p>
      </div>
    </div>
  );
};

export default HostingerGuide;
